import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      title: 'Start New Search',
      description: 'Find properties that match your criteria',
      icon: 'Search',
      variant: 'default',
      onClick: () => navigate('/property-search-browse')
    },
    {
      title: 'View Saved Properties',
      description: 'Browse your favorite listings',
      icon: 'Heart',
      variant: 'outline',
      onClick: () => navigate('/saved-properties')
    },
    {
      title: 'Create Alert',
      description: 'Get notified of new matching properties',
      icon: 'Bell',
      variant: 'outline',
      onClick: () => navigate('/property-search-browse') // Assuming alerts are created from search page
    },
    {
      title: 'Schedule Tour',
      description: 'Book a viewing appointment',
      icon: 'Calendar',
      variant: 'outline',
      onClick: () => navigate('/property-search-browse') // Assuming tours are scheduled from property details or search
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action, index) => (
          <Button
            key={index}
            variant={action?.variant}
            onClick={action?.onClick}
            iconName={action?.icon}
            iconPosition="left"
            className="h-auto p-4 justify-start"
          >
            <div className="text-left">
              <div className="font-medium">{action?.title}</div>
              <div className="text-sm text-muted-foreground mt-1">
                {action?.description}
              </div>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
